import { useCallback } from 'react';
import { useAuthStore } from '@/lib/auth/store';
import { BASE_PERMISSION } from '@/lib/constants/modules';
import { hasPermission, usePermissionStore } from './store';

/** Platform module id → ACL module name (only modules that have an ACL entry). */
const MODULE_ACL_NAME: Record<string, string> = {
  '5': 'Manage CLI',
  '6': 'Inbound',
  '16': 'API Docs',
};

/**
 * Returns a predicate: can the current user hand out this platform module?
 * - Sub-superadmin: own ACL must grant view on the matching ACL module.
 * - Reseller / user under a sub-superadmin: that sub-superadmin's ACL.
 * - Everyone else (superadmin tree): unrestricted.
 */
export function useAclModuleGate(): (moduleId: string | number) => boolean {
  const isSub = useAuthStore((s) => s.isSubSuperAdmin());
  const perms = usePermissionStore((s) => s.perms);
  const inherited = usePermissionStore((s) => s.inheritedPerms);
  return useCallback(
    (moduleId) => {
      const aclName = MODULE_ACL_NAME[String(moduleId)];
      if (!aclName) return true;
      if (isSub) return hasPermission(perms, aclName, BASE_PERMISSION.VIEW);
      if (!inherited) return true;
      return Boolean(inherited[aclName]?.view_permission);
    },
    [isSub, perms, inherited],
  );
}
